define('webshopCategoriesDetailBodyUrlsBodyDomainErrorModalView',[
  'module',
  'marionette',
  'underscore',
  'buttonView',  
  'template!webshopCategoriesDetailBodyUrlsBodyDomainErrorModalView'
], function(
  Module,
  Marionette,
  _,
  ButtonView,
  Tpl
) {
  'use strict';

  Module.exports = Marionette.LayoutView.extend({
    template: Tpl,
    className: 'webshop-categories-detail-body-urls-body-domain-error-modal-view',

    regions: {
      categoryButtonRegion: '.category-button-region'
    },

    initialize: function(options) {
      this.errorMessage = options.errorMessage;
      this.parentId = options.parentId;
    },

    serializeData: function() {
      var data = {};
      data.errorMessage = this.errorMessage;
      data.hasParentId = !!this.parentId;
      return data;
    },

    onRender: function() {
      if (this.parentId) {
        this.categoryButton = new ButtonView({
          type: 'goto',
          color: 'green',
          text: _.i18n('common.category')
        });
        this.getRegion('categoryButtonRegion').show(this.categoryButton);
        this.categoryButton.on('click', _.bind(this.onOpenCategory, this));
      }
    },

    onOpenCategory: function() {
      require(['webshopCategoriesDetailView'], _.bind(function(View) {
        View.prototype.open(this.parentId);

        if(this.parentView)
          this.parentView.close();
      }, this));
    }
  });
});

